import { useEffect } from 'react';
import moment from 'moment';
import { setTimeFormat } from '../../../../../util';

export const useAppointmentFormEdit = ({
  id,
  appointmentById,
  form,
  setOption,
  setPackageId,
  setPromotionId,
  setDate,
  setStartTime,
  setTerm,
  setTreatmentTypeId,
  setIsBefore,
  setIsScheduled,
  setIsEditable,
  setIsInProcess,
  isEditable,
}) => {
  useEffect(() => {
    if (!id || !appointmentById) return;

    setOption(appointmentById?.appointmentOption);
    setPackageId(isEditable ? appointmentById?.pendingProduct?.pkg?.id : '');
    setPromotionId(isEditable ? appointmentById?.pendingProduct?.pkg?.id : '');
    setDate(appointmentById?.date);
    setStartTime(appointmentById?.startTime);
    setTerm(appointmentById?.term);
    setTreatmentTypeId(appointmentById?.treatment?.treatmentType?.id);

    setIsBefore(
      moment(`${appointmentById?.date} ${appointmentById?.endTime}`).isBefore(
        moment()
      )
    );

    setIsScheduled(appointmentById?.status === 'scheduled');
    setIsEditable(['scheduled', 'inProcess'].includes(appointmentById?.status));
    setIsInProcess(['inProcess'].includes(appointmentById?.status));
  }, [id, appointmentById]);

  useEffect(() => {
    if (!id || !appointmentById) return;

    form.setFieldsValue({
      ...appointmentById,
      branchId: appointmentById?.branch?.id,
      date: moment(appointmentById?.date),
      startTime: setTimeFormat(appointmentById?.startTime),
      term: appointmentById?.term
        ? setTimeFormat(appointmentById?.term)
        : appointmentById?.term,
      cabainId: appointmentById?.cabain?.id,
      customerId: appointmentById?.customer?.id,
      customerName: `${appointmentById?.customer?.name} ${appointmentById?.customer?.lastName}`,
    });
  }, [id, appointmentById, form]);
};
